import { useEffect, useState } from "react";
import useModule from "../../../hooks/useModule";
import FiltersButton from "../../SavedFilters/FiltersButton";
import DisplayRecord from "../DisplayRecord";
import EmptyField from "../EmptyField";
import useReadableText from "../../../hooks/useReadableText";
import AppSpinner from "../../../elements/AppSpinner";

interface Props {
  field: any;
  existingValue: any;
  mode: string;
  moduleAPIName: string;
  type: string;
  tableView: boolean;
  modifyTrigger: any;
  onUpdate: any;
  recordID: string;
  submitting: boolean;
}

export default function FilterRecord({
  field,
  existingValue,
  mode,
  moduleAPIName,
  type,
  tableView,
  modifyTrigger,
  onUpdate,
  recordID,
  submitting,
}: Props) {
  const filterMod = field?.SourcesList;
  const { module } = useModule(filterMod);
  const [query, setQuery] = useState({ Filters: [] });

  const { readableText } = useReadableText({
    query,
    moduleAPIName,
    fallbackMessage: "--",
  });

  useEffect(() => {
    setQuery(existingValue || { Filters: [] });
  }, [existingValue]);

  return (
    <FiltersButton
      currentModule={module}
      query={query}
      setQuery={setQuery}
      onApply={(newQuery: any) => {
        setQuery(newQuery);
        handleUpdate(newQuery);
      }}
      onClear={() => {
        setQuery({ Filters: [] });
        handleUpdate(null);
      }}
      checkForFields={false}
      customComponent={({ onClick }) => {
        return (
          <div>
            <DisplayRecord
              mode={mode as "r" | "rw"}
              tableView={tableView}
              modifyTrigger={modifyTrigger}
              openModify={onClick}
              isSensitive={field?.Sensitive ?? false}
              displayComponent={(_: any, innerRef: any) => (
                <div
                  onClick={onClick}
                  ref={innerRef}
                  style={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    display: "-webkit-box",
                    WebkitLineClamp: 3,
                    WebkitBoxOrient: "vertical",
                  }}
                >
                  {submitting && <AppSpinner size="sm" />}
                  {!submitting && existingValue && readableText}
                  {!submitting && !existingValue && (
                    <EmptyField table={tableView} />
                  )}
                </div>
              )}
            />
          </div>
        );
      }}
    />
  );

  function handleUpdate(newQuery: any) {
    onUpdate({
      field,
      recordID,
      payload: { [field.APIName]: newQuery },
      onSuccess: () => {},
    });
  }
}
